import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';

// Utility to fix existing wrong questions that don't have options or correct answers
export const fixWrongQuestionsOptions = async () => {
  try {
    
    // Get all wrong questions from the revision_data collection
    const wrongQuestionsRef = collection(db, 'revision_data');
    const q = query(wrongQuestionsRef, where('type', '==', 'wrongQuestion'));
    const querySnapshot = await getDocs(q);
    
    let fixedCount = 0;
    let totalCount = 0;
    const updates = [];
    
    querySnapshot.forEach((document) => {
      totalCount++;
      const data = document.data();
      let needsUpdate = false;
      const updatedData = { ...data };
      
      // Check if the question doesn't have options or has empty options
      if (!data.options || data.options.length === 0) {
        // Add placeholder options based on the question type
        updatedData.options = ['Option A', 'Option B', 'Option C', 'Option D'];
        updatedData.type = data.type || 'multiple-choice';
        needsUpdate = true;
      }
      
      // Check if correct answer is missing or empty
      if (!data.correctAnswer || data.correctAnswer === '') {
        // Try to infer from user answer or set a placeholder
        if (data.userAnswer && data.userAnswer !== '') {
          // If user answered but was wrong, we can't infer the correct answer
          updatedData.correctAnswer = 'Answer not available';
        } else {
          updatedData.correctAnswer = 'Answer not available';
        }
        needsUpdate = true;
      }
      
      // Ensure question type is set
      if (!data.type) {
        updatedData.type = 'multiple-choice';
        needsUpdate = true;
      }
      
      // Ensure course, subject, and chapter are set
      if (!data.course) {
        updatedData.course = 'General Course';
        needsUpdate = true;
      }
      
      if (!data.subject) {
        updatedData.subject = data.topic || 'General';
        needsUpdate = true;
      }
      
      if (!data.chapter) {
        updatedData.chapter = 'General Chapter';
        needsUpdate = true;
      }
      
      if (needsUpdate) {
        updates.push({
          id: document.id,
          data: updatedData
        });
        fixedCount++;
      }
    });
    
    // Batch update all documents
    for (const update of updates) {
      try {
        await updateDoc(doc(db, 'revision_data', update.id), update.data);
      } catch (error) {
      }
    }
    
    return { success: true, fixedCount, totalCount };
    
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Function to check the status of wrong questions
export const checkWrongQuestionsStatus = async () => {
  try {
    const wrongQuestionsRef = collection(db, 'revision_data');
    const q = query(wrongQuestionsRef, where('type', '==', 'wrongQuestion'));
    const querySnapshot = await getDocs(q);
    
    let withOptions = 0;
    let withoutOptions = 0;
    let totalCount = 0;
    
    querySnapshot.forEach((document) => {
      totalCount++;
      const data = document.data();
      
      if (data.options && data.options.length > 0) {
        withOptions++;
      } else {
        withoutOptions++;
      }
    });
    
    // Wrong Questions Status
    // Total
    // With options
    // Without options
    
    return { success: true, totalCount, withOptions, withoutOptions };
    
  } catch (error) {
    // Error checking wrong questions status
    return { success: false, error: error.message };
  }
};
